<template>
  <div class="margin-b-standard">
    <RightSidebarTitle :title="'Media Content'" />
    <p class="not-supported-message">This tool is no longer supported.</p>
  </div>
</template>
<script lang="ts" setup>
import RightSidebarTitle from "@/components/right-sidebars/ui/RightSidebarTitle.vue";
</script>
<style scoped lang="scss">
.not-supported-message {
  font-size: 0.875rem;
}
</style>
